import { useRef } from 'react';
import type { FC, ReactNode } from 'react';

import { useDealAssistant } from '@makemydeal/dr-dash-deal-assistant';

import { DealAssistantDockedPanel } from './DealAssistantDockedPanel';
import { LayoutContent, LayoutRoot } from './DealAssistantHost.style';
import { useCardsOverflow } from './useCardsOverflow';

export const DealAssistantPanelLayout: FC<{ children: ReactNode }> = ({ children }) => {
    const { isOpen } = useDealAssistant();
    const contentRef = useRef<HTMLDivElement>(null);
    const cardsOverflow = useCardsOverflow(contentRef, isOpen);

    return (
        <LayoutRoot data-testid="deal-assistant-layout">
            <LayoutContent ref={contentRef} $isPanelOpen={isOpen}>
                {children}
            </LayoutContent>
            <DealAssistantDockedPanel offset={cardsOverflow} />
        </LayoutRoot>
    );
};
